module.exports = __webpack_public_path__ + "img/why-ai-agents-break-in-production.6e15f98f.webp";